import { brandName, heroStats, hotRanking } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative isolate overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20newsroom%20collage%20with%20floating%20magazine%20covers%20and%20trending%20topic%20cards%2C%20warm%20coral%20and%20amber%20gradient%20lighting%2C%20grainy%20editorial%20illustration%20style%2C%20no%20text%2C%20cinematic%20composition&width=1800&height=1200&seq=cgk-hero-01&orientation=landscape"
          alt="吃瓜看料实时热点资讯现场氛围视觉"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/78 to-foreground-950/45" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/40" />
      </div>

      <div className="relative w-full px-4 md:px-8 pt-32 pb-16 md:pt-44 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7 w-full">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/40 text-primary-100 text-xs font-label font-medium tracking-wide">
              <span className="w-2 h-2 rounded-full bg-primary-400 pulse-dot" aria-hidden="true" />
              现场直击 · 实时速递
            </span>

            <h2 className="mt-6 font-heading text-4xl md:text-6xl font-black leading-[1.15] text-background-50">
              热点不隔夜
              <br />
              前线<span className="text-secondary-400">第一时间</span>围观
            </h2>

            <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-background-100/85">
              {brandName}
              专注实时热点与深度爆料，追踪全网热门事件、内幕解析与网友热议精选，
              帮你快速掌握事件全貌，不错过任何精彩瞬间。
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <a
                href="#live"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
              >
                进入实时前线
                <i className="ri-flashlight-line" aria-hidden="true" />
              </a>
              <a
                href="#deep"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-background-50/20"
              >
                看深度爆料
                <i className="ri-article-line" aria-hidden="true" />
              </a>
            </div>

            <dl className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-2xl">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="text-xs font-label text-background-100/70">{stat.label}</dt>
                  <dd className="mt-1.5 font-heading text-2xl md:text-3xl font-black text-background-50">
                    {stat.value}
                    <span className="ml-1 text-sm font-medium text-secondary-400">{stat.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="lg:col-span-5 w-full">
            <div className="rounded-lg border border-background-50/20 bg-background-50/10 backdrop-blur-md p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold text-background-50 flex items-center gap-2">
                  <i className="ri-fire-line text-secondary-400" aria-hidden="true" />
                  此刻热搜
                </h3>
                <span className="text-xs font-label text-background-100/70">每 5 分钟刷新</span>
              </div>
              <ol className="mt-5 space-y-1">
                {hotRanking.slice(0, 5).map((item, index) => (
                  <li key={item.id}>
                    <a
                      href="#live"
                      className="flex items-center gap-3 py-2.5 px-2 rounded-md cursor-pointer transition-colors hover:bg-background-50/10"
                    >
                      <span
                        className={`w-6 text-center font-heading font-black ${
                          index < 3 ? "text-primary-400" : "text-background-100/60"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="flex-1 text-sm text-background-50 truncate">{item.label}</span>
                      <span className="text-xs font-label text-secondary-300 whitespace-nowrap">
                        {item.heat}
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
              <a
                href="#live"
                className="mt-4 flex items-center justify-center gap-1.5 w-full py-2.5 rounded-md border border-background-50/25 text-sm text-background-50 cursor-pointer transition-colors hover:bg-background-50/15"
              >
                查看完整榜单
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}